import { UUID } from '@previo/core'
import { useLocalStorage } from '@vueuse/core'
import type { Ref } from 'vue'
import { LocalStorageKeyManager, LocalStorageKeys } from '~/store/LocalStorageKeyManager'

export const useDeviceIdLocalStore = (): Ref<string> =>
  useLocalStorage<string>(
    LocalStorageKeyManager.createStorageKey(LocalStorageKeys.DEVICE_UD),
    UUID.v7(),
  )
